import { useEffect, useState } from 'react';
import api from '../services/api';
import Button from '../components/Button';
import Input from '../components/Input';
import Select from '../components/Select';

export default function ClaimSettings() {
  const [settings, setSettings] = useState<any>(null);

  useEffect(() => {
    api.get('/ecs/settings').then((res) => setSettings(res.data.settings));
  }, []);

  const setField = (k: string, v: any) => setSettings((s: any) => ({ ...s, [k]: v }));

  const save = async () => {
    try {
      const res = await api.put('/ecs/settings', {
        allowExceedLimit: settings.allow_exceed_limit,
        cancellationApproverMode: settings.cancellation_approver_mode,
        receiptDateValidationMonths: settings.receipt_date_validation_months,
        customField1Label: settings.custom_field_1_label,
        customField2Label: settings.custom_field_2_label,
        customField3Label: settings.custom_field_3_label,
        customField4Label: settings.custom_field_4_label,
        customField5Label: settings.custom_field_5_label,
        prorationMethod: settings.proration_method,
      });
      setSettings(res.data.settings);
      alert('Saved');
    } catch (err: any) {
      alert(err.response?.data?.message || 'Failed to save');
    }
  };

  if (!settings) return <div className="p-6">Loading...</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Claim Utility Settings</h1>
      <div className="bg-white rounded-lg shadow p-6 space-y-4 max-w-2xl">
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={!!settings.allow_exceed_limit} onChange={(e) => setField('allow_exceed_limit', e.target.checked)} />
          Allow claims to exceed configured limits
        </label>
        <Select
          label="Cancellation Approver Mode"
          value={settings.cancellation_approver_mode || 'FINAL'}
          onChange={(e) => setField('cancellation_approver_mode', e.target.value)}
          options={[
            { value: 'FINAL', label: 'Final level approver only' },
            { value: 'ALL', label: 'All levels (full chain replay)' },
            { value: 'IMMEDIATE', label: 'Immediate — no approval needed' },
          ]}
        />
        <Input
          label="Receipt Date Validation (months, 0 = off)"
          type="number"
          value={settings.receipt_date_validation_months ?? 0}
          onChange={(e) => setField('receipt_date_validation_months', parseInt(e.target.value, 10) || 0)}
        />
        <Select
          label="Proration Method"
          value={settings.proration_method || 'NONE'}
          onChange={(e) => setField('proration_method', e.target.value)}
          options={[
            { value: 'NONE', label: 'None' },
            { value: 'FINANCIAL_YEAR', label: 'Financial Year (prorate yearly limits for mid-year joiners)' },
          ]}
        />
        <div className="grid grid-cols-2 gap-4">
          {[1, 2, 3, 4, 5].map((n) => (
            <Input
              key={n}
              label={`Custom Field ${n} Label`}
              value={settings[`custom_field_${n}_label`] || ''}
              onChange={(e) => setField(`custom_field_${n}_label`, e.target.value)}
              maxLength={50}
            />
          ))}
        </div>
        <Button onClick={save}>Save Settings</Button>
      </div>
    </div>
  );
}
